<div class="scene-tool-bar1" [class.toolbar-hidden]="toolbarHidden">
    <div class="toolbar-groups">
        <!-- file -->
        <div class="toolbar-group">
            <div class="toolbar-group-label">file</div>
            <div class="toolbar-group-buttons">
                <button class="icon-button buttonBarButt hide-below-600" mat-button (click)="backScene()">
                    <mat-icon matTooltip="exit" class="buttonBarIcon flipped-icon" style="transform: scaleX(-1);">
                        logout
                    </mat-icon>
                </button>
                <button class="icon-button buttonBarButt exit-small-screen" mat-button (click)="backScene()"
                        matTooltip="{{'navigation.exitScene' | transloco}}">
                    <mat-icon class="buttonBarIcon flipped-icon" style="transform: scaleX(-1);">logout</mat-icon>
                </button>
                <button class="icon-button buttonBarButt" mat-button (click)="saveChanges(true);"
                        [disabled]="!saveMode.saveSceneManual">
                    @if (savedIcon) {
                        <fa-icon size="xl" [icon]="['fas', 'floppy-disk']"
                                 matTooltip="{{'general.save' | transloco}} [Alt+S]"></fa-icon>
                    } @else {
                        <fa-icon size="xl" [icon]="faFloppyDisk"
                                 matTooltip="{{'general.save' | transloco}} [Alt+S]"></fa-icon>
                    }
                </button>
                <button class="txtColorHighlight icon-button buttonBarButt" mat-button (click)="showPreviewPopup();"
                        matTooltip="{{'general.preview' | transloco}}">
                    <mat-icon class="buttonBarIcon">play_circle</mat-icon>
                </button>
                <button class="icon-button buttonBarButt hide-below-1600" mat-button (click)="openPaletteSelector();"
                        matTooltip="{{'ai.colorPaletteSelector' | transloco}}">
                    <mat-icon class="buttonBarIcon">palette</mat-icon>
                </button>
                @if (sceneData.Player.$.mimeType == 'mainPlayer') {
                    <button matTooltip="{{'general.registerPlayer' | transloco}}"
                            class="icon-button buttonBarButt hide-below-1600" mat-button
                            (click)="showAddPlayerModal();">
                        <mat-icon>queue_play_next</mat-icon>
                    </button>
                }
                <button class="goBack-btn icon-button buttonBarButt" mat-button (click)="backSceneList()"
                        matTooltip="{{'navigation.exitScene' | transloco}}">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <!-- history -->
        <div class="toolbar-group">
            <div class="toolbar-group-label">history</div>
            <div class="toolbar-group-buttons">
                @if (experienceLevel > experienceLevelType.BEGINNER) {
                    <button class="icon-button buttonBarButt hide-below-1400" mat-button (click)="toggleDragScene();">
                        @if (dragSceneEnabled) {
                            <fa-icon size="xl" [icon]="faHand" matTooltip="{{'scenes.move' | transloco}}"></fa-icon>
                        } @else {
                            <fa-icon size="xl" [icon]="farHand" matTooltip="{{'scenes.move' | transloco}}"></fa-icon>
                        }
                    </button>
                }
                <button matTooltip="{{'general.undo' | transloco}} [Ctrl+Z]" class="icon-button buttonBarButt"
                        mat-button
                        (click)="onUndoRedo('UNDO');" [disabled]="disableUndo">
                    <mat-icon class="buttonBarIcon">undo</mat-icon>
                </button>
                <button matTooltip="{{'general.redo' | transloco}} [Ctrl+Y]" class="icon-button buttonBarButt"
                        mat-button
                        (click)="onUndoRedo('REDO');" [disabled]="disableRedo">
                    <mat-icon class="buttonBarIcon">redo</mat-icon>
                </button>
            </div>
        </div>
        <!-- clipboard -->
        <div class="toolbar-group hide-below-600">
            <div class="toolbar-group-label">clipboard</div>
            <div class="toolbar-group-buttons">
                <button matTooltip="{{'general.copy' | transloco}} [Ctrl+C]" class="icon-button buttonBarButt"
                        mat-button (click)="onClickCopy();" [disabled]="selectedItemIds.length == 0">
                    <fa-icon [icon]="faCopy"></fa-icon>
                </button>
                <button matTooltip="{{'general.paste' | transloco}} [Ctrl+V]" class="icon-button buttonBarButt"
                        mat-button (click)="onClickPaste(true);" [disabled]="!isCut && !isCopy">
                    <fa-icon [icon]="faPaste"></fa-icon>
                </button>
                <button matTooltip="{{'general.cut' | transloco}} [Ctrl+X]" class="icon-button buttonBarButt"
                        mat-button (click)="onClickCut();" [disabled]="selectedItemIds.length == 0">
                    <fa-icon [icon]="faCut"></fa-icon>
                </button>
                <button matTooltip="{{'general.removeItems' | transloco}} [Delete]"
                        class="icon-button buttonBarButt" mat-button
                        (click)="removeSceneItems()" [disabled]="selectedItemIds.length == 0">
                    <mat-icon class="buttonBarIcon">delete</mat-icon>
                </button>
            </div>
        </div>
        @if (experienceLevel > experienceLevelType.BEGINNER) {
            <!-- visibility -->
            <div class="toolbar-group hide-lt-sm">
                <div class="toolbar-group-label">visibility</div>
                <div class="toolbar-group-buttons">
                    <button matTooltip="{{'general.lockItem' | transloco}}" class="icon-button buttonBarButt"
                            mat-button (click)="onClickLock();" [disabled]="selectedItemIds.length == 0">
                        <fa-icon [icon]="faLock"></fa-icon>
                    </button>
                    <button matTooltip="{{'general.unlockallitems' | transloco}}" class="icon-button buttonBarButt"
                            mat-button (click)="onClickUnlockAll();">
                        <fa-icon [icon]="faLockOpen"></fa-icon>
                    </button>
                    <button matTooltip="{{'general.hideItem' | transloco}}" class="icon-button buttonBarButt"
                            mat-button (click)="onClickHide();" [disabled]="selectedItemIds.length == 0">
                        <fa-icon [icon]="faEyeSlash"></fa-icon>
                    </button>
                    <button matTooltip="{{'general.showAll' | transloco}}" class="icon-button buttonBarButt"
                            mat-button (click)="onClickShowAll();">
                        <fa-icon [icon]="faEye"></fa-icon>
                    </button>
                </div>
            </div>
            <!-- guides -->
            <div class="toolbar-group hide-lt-sm">
                <div class="toolbar-group-label">guides</div>
                <div class="toolbar-group-buttons">
                    <button class="icon-button buttonBarButt" mat-button (click)="onClickChangeMagnetic();">
                        @if (showDirections) {
                            <fa-icon [icon]="faMagnet" size="xl" class="buttonBarIcon"
                                     matTooltip="{{'general.magneticAlignmentOff' | transloco}}"></fa-icon>
                        }
                        @if (!showDirections) {
                            <fa-icon [icon]="faMagnet" size="xl" style="opacity: 0.5" class="buttonBarIcon"
                                     matTooltip="{{'general.magneticAlignmentOn' | transloco}}"></fa-icon>
                        }
                    </button>
                    <button matTooltip="{{'general.toggleGuide' | transloco}} [Ctrl+L]"
                            class="icon-button buttonBarButt"
                            mat-button (click)="onClickSetGuidelines();">
                        <mat-icon class="buttonBarIcon">vertical_align_center</mat-icon>
                    </button>
                    <button matTooltip="{{'general.keyboard' | transloco}}" class="icon-button buttonBarButt"
                            mat-button (click)="onKeyboardHelp();">
                        <mat-icon class="buttonBarIcon">keyboard</mat-icon>
                    </button>
                </div>
            </div>
            <!-- background -->
            <div class="toolbar-group hide-below-600">
                <div class="toolbar-group-label">background</div>
                <div class="toolbar-group-buttons">
                    <button matTooltip="{{'general.setBackground' | transloco}}"
                            class="icon-button buttonBarButt" mat-button
                            (click)="convertToBackground();"
                            [disabled]="selectedItemIds.length !== 1 || !enableBackground">
                        <mat-icon class="buttonBarIcon">wallpaper</mat-icon>
                    </button>
                    <button matTooltip="{{'general.importBackground' | transloco}}"
                            class="icon-button buttonBarButt" mat-button
                            (click)="popupBackgroundWnd();">
                        <mat-icon class="buttonBarIcon">add_photo_alternate</mat-icon>
                    </button>
                    <button matTooltip="{{'general.about' | transloco}}" class="icon-button buttonBarButt"
                            mat-button (click)="onAbout();">
                        <fa-icon [icon]="sceneData?.Player.$.mimeType | PipeIcon"></fa-icon>
                    </button>
                </div>
            </div>
        }
        <!-- more -->
        <div class="toolbar-group toolbar-group-more">
            <div class="toolbar-group-label">more</div>
            <div class="toolbar-group-buttons">
                <button #overflowMenuTrigger class="icon-button buttonBarButt overflow-menu-trigger" mat-button
                        [matMenuTriggerFor]="toolbarOverflow"
                        matTooltip="{{'general.options' | transloco}}">
                    <mat-icon class="buttonBarIcon">more_horiz</mat-icon>
                </button>
                <mat-menu #toolbarOverflow="matMenu" class="toolbar-overflow-menu">
                    <button mat-menu-item (click)="openPaletteSelector()" class="responsive-menu-item">
                        <mat-icon>palette</mat-icon>
                        <span>{{ 'ai.colorPaletteSelector' | transloco }}</span>
                    </button>
                    @if (sceneData.Player.$.mimeType == 'mainPlayer') {
                        <button mat-menu-item (click)="showAddPlayerModal()" class="responsive-menu-item">
                            <mat-icon>queue_play_next</mat-icon>
                            <span>{{ 'general.registerPlayer' | transloco }}</span>
                        </button>
                    }
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="onClickCopy()" [disabled]="selectedItemIds.length == 0"
                            class="responsive-menu-item">
                        <mat-icon>content_copy</mat-icon>
                        <span>{{ 'general.copy' | transloco }} [Ctrl+C]</span>
                    </button>
                    <button mat-menu-item (click)="onClickPaste(true)" [disabled]="!isCut && !isCopy"
                            class="responsive-menu-item">
                        <mat-icon>content_paste</mat-icon>
                        <span>{{ 'general.paste' | transloco }} [Ctrl+V]</span>
                    </button>
                    <button mat-menu-item (click)="onClickCut()" [disabled]="selectedItemIds.length == 0"
                            class="responsive-menu-item">
                        <mat-icon>content_cut</mat-icon>
                        <span>{{ 'general.cut' | transloco }} [Ctrl+X]</span>
                    </button>
                    <button mat-menu-item (click)="removeSceneItems()" [disabled]="selectedItemIds.length == 0"
                            class="responsive-menu-item">
                        <mat-icon>delete</mat-icon>
                        <span>{{ 'general.removeItems' | transloco }} [Delete]</span>
                    </button>
                    @if (experienceLevel > experienceLevelType.BEGINNER) {
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="toggleDragScene()" class="responsive-menu-item">
                            <mat-icon>pan_tool</mat-icon>
                            <span>{{ 'scenes.move' | transloco }}</span>
                        </button>
                        <button mat-menu-item (click)="onClickLock()" [disabled]="selectedItemIds.length == 0"
                                class="responsive-menu-item">
                            <mat-icon>lock</mat-icon>
                            <span>{{ 'general.lockItem' | transloco }}</span>
                        </button>
                        <button mat-menu-item (click)="onClickUnlockAll()" class="responsive-menu-item">
                            <mat-icon>lock_open</mat-icon>
                            <span>{{ 'general.unlockallitems' | transloco }}</span>
                        </button>
                        <button mat-menu-item (click)="onClickHide()" [disabled]="selectedItemIds.length == 0"
                                class="responsive-menu-item">
                            <mat-icon>visibility_off</mat-icon>
                            <span>{{ 'general.hideItem' | transloco }}</span>
                        </button>
                        <button mat-menu-item (click)="onClickShowAll()" class="responsive-menu-item">
                            <mat-icon>visibility</mat-icon>
                            <span>{{ 'general.showAll' | transloco }}</span>
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="onClickChangeMagnetic()" class="responsive-menu-item">
                            <mat-icon>adjust</mat-icon>
                            <span>{{ showDirections ? ('general.magneticAlignmentOff' | transloco) : ('general.magneticAlignmentOn' | transloco) }}</span>
                        </button>
                        <button mat-menu-item (click)="onClickSetGuidelines()" class="responsive-menu-item">
                            <mat-icon>vertical_align_center</mat-icon>
                            <span>{{ 'general.toggleGuide' | transloco }} [Ctrl+L]</span>
                        </button>
                        <button mat-menu-item (click)="onKeyboardHelp()" class="responsive-menu-item">
                            <mat-icon>keyboard</mat-icon>
                            <span>{{ 'general.keyboard' | transloco }}</span>
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="convertToBackground()"
                                [disabled]="selectedItemIds.length !== 1 || !enableBackground"
                                class="responsive-menu-item">
                            <mat-icon>wallpaper</mat-icon>
                            <span>{{ 'general.setBackground' | transloco }}</span>
                        </button>
                        <button mat-menu-item (click)="popupBackgroundWnd()" class="responsive-menu-item">
                            <mat-icon>add_photo_alternate</mat-icon>
                            <span>{{ 'general.importBackground' | transloco }}</span>
                        </button>
                        <button mat-menu-item (click)="onAbout()" class="responsive-menu-item">
                            <mat-icon>info</mat-icon>
                            <span>{{ 'general.about' | transloco }}</span>
                        </button>
                    }
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="backSceneList()" class="responsive-menu-item">
                        <mat-icon>close</mat-icon>
                        <span>{{ 'navigation.exitScene' | transloco }}</span>
                    </button>
                </mat-menu>
                <div class="position d-flex-center hide-below-600">
                    <app-video-link style="display: inline-block;" videoLink="sceneEditor"></app-video-link>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="scene-wrapper" [ngClass]="{selectedBorder: isEditorFocus, notSelectedBorder: !isEditorFocus }"
     fxLayout="row">
    @if (!slideEditMode) {
        <div class="ruler-origin"></div>

        @if (!isMouseOut) {
            <div class="mouse-tick-x" [ngStyle]="{'left': mousePosition[2] + 'px'}"></div>
        }
        @if (!isMouseOut) {
            <div class="mouse-tick-y" [ngStyle]="{'top': mousePosition[3] + 'px'}"></div>
        }
    }

    <div class="page main scene-container colored-scrollbar"
         [ngClass]="{ dragging: dragSceneEnabled, slide: slideEditMode }">
        <div class="editor">
            @if (!slideEditMode) {
                <div class="horizontal ruler">
                    <app-timeline-ruler
                        [width]="editorWidth*zoom"
                        [minWidth]="rulerMinWidth"
                        [height]="30"
                        [position]="0"
                        [unitsTime]="false"
                        [zoom]="zoom">
                    </app-timeline-ruler>
                </div>
                <div class="vertical ruler">
                    <app-timeline-ruler
                        [width]="30"
                        [height]="editorHeight*zoom"
                        [minHeight]="rulerMinHeight"
                        [position]="0"
                        [unitsTime]="false"
                        [zoom]="zoom"
                        [vertical]="true">
                    </app-timeline-ruler>
                </div>
            }

            <div class="view" id="viewSceneContainer"
                 [ngClass]="{
                    viewBackground0: sceneCheckeredBackground === '0',
                    viewBackground1: sceneCheckeredBackground === '1',
                    viewBackground2: sceneCheckeredBackground === '2',
                    viewBackground3: sceneCheckeredBackground === '3',
                    slide: slideEditMode
                 }"
                 [ngStyle]="{
                    'background-size': 20*zoom + 'px ' + 20*zoom + 'px',
                    'background-position': '0 0, 0 ' + 10*zoom + 'px, ' + 10*zoom + 'px -' + 10*zoom + 'px, -' + 10*zoom + 'px 0'
                 }"
                 (mousemove)="onMouseMoveView($event)"
                 (mousedown)="onMouseDownView($event)"
                 (mouseup)="onMouseUpView($event)"
                 (mouseout)="onMouseOutView()"
                 (mouseover)="onMouseOverView()">

                <app-scene-moveable
                    [setSelectedSceneId]="selectedSceneId"
                    [setGuidelines]="guidelines"
                    [setEditorWidth]="editorWidth"
                    [setEditorHeight]="editorHeight"
                    [setShowDirections]="showDirections"
                    [changeSelect]="changeSelect"
                    [resolution]="resolution"
                    [slideEditMode]="slideEditMode"
                    (mousedown)="onMouseDownMoveable($event)"
                    (updateSceneItems)="onUpdateSceneItems($event)"
                    (sceneLoaded)="onSceneLoaded($event)"
                    (contextmenu)="showContextMenu($event)"
                    (dblclick)="onDoubleClickSceneItem($event)"
                    (customAction)="onCustomAction($event)">
                </app-scene-moveable>

                <!-- Canva Embedded -->
                <!-- <div style="position: relative; width: 300px; height: 300px;" *ngIf="testCanva">
                <iframe src="https://www.canva.com/design/DAF45mLCgtM/W21fD8Dn8RQlerMqlpIsgw/view?embed"  allowfullscreen="allowfullscreen" allow="fullscreen" loading="lazy" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0;margin: 0;">
                </iframe>
              </div> -->

                <!-- <div>
                              <div style="position: relative; width: 100%; height: 0; padding-top: 100.0000%;
                                  padding-bottom: 0; box-shadow: 0 2px 8px 0 rgba(63,69,81,0.16); margin-top: 1.6em; margin-bottom: 0.9em; overflow: hidden;
                                  border-radius: 8px; will-change: transform;">
                  <iframe loading="lazy" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; border: none; padding: 0;margin: 0;"
                    src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAF45mLCgtM&#x2F;view?embed" allowfullscreen="allowfullscreen" allow="fullscreen">
                  </iframe>
                </div>
              </div> -->

                <!-- (mousedown)="onMouseDownMultiSceneItem($event)" -->
                <!-- (contextmenu)="onRightClick($event)"
                [contextMenu]="itemMenuMoveable"
                [contextMenuSubject]="" -->
                <!-- (mousedown)="onMouseDownMultiSceneItem($event)"
                (dblclick)="onDoubleClickMoveable($event)"
                (click)="onClickMoveable($event)" -->

                @if (isShowLines) {
                    <app-ngx-guidelines
                        [setGuidelines]="guidelines"
                        [setHidelines]="hidelines"
                        [guidelineOpacity]="guidelineOpacity"
                        [editorWidth]="editorWidth"
                        [editorHeight]="editorHeight"
                        (changeGuidelines)="changeGuidelines()">
                    </app-ngx-guidelines>
                }
            </div>

            @if (!accessConfig?.upd) {
                <div id="locked-editor">
                    <div class="locked-line"
                         style="position: absolute; top: 50%; left: 0; width: 100%; height: 2px;"></div>
                    <div class="locked-line"
                         style="position: absolute; top: 0; left: 50%; width: 2px; height: 100%;"></div>
                    <div id="locked-icon">
                        <mat-icon class="buttonBarIcon" matTooltip="No permission to edit scene">lock_open</mat-icon>
                    </div>
                </div>
            }

            @if (dragSceneEnabled) {
                <div id="sceneOverlay" class="scene-overlay"
                     (mousedown)="onMouseDownOverlay($event)"
                     (mousemove)="onMouseMoveOverlay($event)"
                     (mouseup)="onMouseUpOverlay($event)">
                </div>
            }
        </div>
    </div>
    @if (!slideEditMode && selectedItemIds.length == 1 && isPlaylist(selectedSceneItemId)) {
        <div class="mini-timeline-wrapper">
            <app-playlist-editor
                [mode]="'playlistMode'"
                [miniView]="true">
            </app-playlist-editor>
        </div>
    }
</div>
<div class="scene-tool-bar2" [class.fixed]="slideEditMode" fxLayoutAlign="start center">
    <div class="d-flex">
        @if (experienceLevel > experienceLevelType.BEGINNER) {
            @if (lockedScene == 'edit') {
                <button class="icon-button buttonBarButt" mat-button disabled>
                    <mat-icon class="buttonBarIcon" style="font-size: 18px; color: lightgreen;"
                              matTooltip="active scene">edit
                    </mat-icon>
                </button>
                <span class="hide-lt-lg d-flex-center" style="min-width: 50px">Editing</span>
            }
            @if (lockedScene == 'locked') {
                <button class="icon-button buttonBarButt" mat-button disabled>
                    <mat-icon class="buttonBarIcon" style="font-size: 18px; color: red;"
                              matTooltip="locked scene by other user">edit
                    </mat-icon>
                </button>
                <span class="hide-lt-lg d-flex-center" style="min-width: 50px">Locked</span>
            }
            @if (!lockedScene) {
                <button class="icon-button buttonBarButt" mat-button disabled>
                    <mat-icon class="buttonBarIcon" style="font-size: 18px; color: gray;" matTooltip="active scene">
                        edit
                    </mat-icon>
                </button>
                <span class="hide-lt-lg d-flex-center" style="min-width: 50px">Saved</span>
            }
        }
        <!-- Zoom controls - always visible -->
        <div class="info d-flex-center" style="margin-left: 10px;">
            <button matTooltip="{{'general.zoomIn' | transloco}} [Alt+(+)]" class="icon-button buttonBarButt" mat-button
                    (click)="onClickZoomIn();" [disabled]="zoomIndex == 0">
                <mat-icon class="buttonBarIcon">zoom_in</mat-icon>
            </button>
            <button matTooltip="{{'general.zoomOut' | transloco}} [Alt+(-)]" class="icon-button buttonBarButt"
                    mat-button (click)="onClickZoomOut();" [disabled]="zoomIndex == zoom_cnt - 1">
                <mat-icon class="buttonBarIcon">zoom_out</mat-icon>
            </button>
            <button matTooltip="{{'general.zoomReset' | transloco}} 100%" class="icon-button buttonBarButt" mat-button
                    (click)="onClickZoomBack();">
                <mat-icon class="buttonBarIcon">youtube_searched_for</mat-icon>
            </button>
            <mat-label style="padding-right: 5px;">&nbsp;[{{ zoom * 100 }}%]</mat-label>
        </div>
    </div>

    <div class="d-flex-center hide-lt-lg">
        @if (experienceLevel > experienceLevelType.BEGINNER) {
            <div class="info info1" style="width: 150px">
                <fa-icon [icon]="faLocationArrow" size="xl"></fa-icon>
                @if (selectedItemIds.length == 0 || scrWidth > 1500) {
                    <span style="min-width: 100px">&nbsp;{{ mousePosition[0] }}, {{ mousePosition[1] }} px</span>
                }
            </div>
        }
    </div>

    @if (selectedItemIds.length > 0) {
        <div class="d-flex-center">
            <button matTooltip="{{'general.pushUp' | transloco}} [Alt+Up]" class="icon-button buttonBarButt" mat-button
                    (click)="onClickForward();">
                <mat-icon class="buttonBarIcon">keyboard_arrow_up</mat-icon>
            </button>
            <button matTooltip="{{'general.pushDown' | transloco}} [Alt+Down]" class="icon-button buttonBarButt"
                    mat-button (click)="onClickBackward();">
                <mat-icon class="buttonBarIcon">keyboard_arrow_down</mat-icon>
            </button>
            <button matTooltip="{{'general.pushTop' | transloco}} [Alt+Shift+Up]" class="icon-button buttonBarButt"
                    mat-button (click)="onClickPushToTop();">
                <mat-icon class="buttonBarIcon" style="transform: rotate(270deg) !important;">double_arrow</mat-icon>
            </button>
            <button matTooltip="{{'general.pushBottom' | transloco}} [Alt+Shift+Down]" class="icon-button buttonBarButt"
                    mat-button (click)="onClickPushToBottom();">
                <mat-icon class="buttonBarIcon" style="transform: rotate(90deg) !important;">double_arrow</mat-icon>
            </button>
            <button matTooltip="{{'general.orientHorizontal' | transloco}} [Ctrl+Shift+O]"
                    class="icon-button buttonBarButt" mat-button (click)="onClickOrientVertical();"
                    [disabled]="!(selectedItemIds.length > 1)">
                <mat-icon class="buttonBarIcon" style="transform: rotate(-90deg) !important;">linear_scale</mat-icon>
            </button>
            <button matTooltip="{{'general.orientVertical' | transloco}} [Ctrl+O]" class="icon-button buttonBarButt"
                    mat-button (click)="onClickOrientHorizontal();" [disabled]="!(selectedItemIds.length > 1)">
                <mat-icon class="buttonBarIcon">linear_scale</mat-icon>
            </button>
            <button matTooltip="{{'scenes.arrangeItems' | transloco}}" class="icon-button buttonBarButt" mat-button
                    [disabled]="!(selectedItemIds.length > 1)" [matMenuTriggerFor]="iconGroup1">
                <mat-icon class="buttonBarIcon" style="transform: rotate(-180deg) !important;">equalizer</mat-icon>
            </button>
            <mat-menu #iconGroup1="matMenu" class="custom-toolbar" [hasBackdrop]="true">
                <button matTooltip="{{'general.arrangeTop' | transloco}}" class="icon-button buttonBarButt"
                        mat-menu-item (click)="alignSceneItems('TOP');">
                    <mat-icon class="buttonBarIcon" style="transform: rotate(-180deg) !important;">equalizer</mat-icon>
                </button>
                <button matTooltip="{{'general.arrangeLeft' | transloco}}" class="icon-button buttonBarButt"
                        mat-menu-item (click)="alignSceneItems('LEFT');">
                    <mat-icon class="buttonBarIcon" style="transform: rotate(-270deg) !important;">equalizer</mat-icon>
                </button>
                <button matTooltip="{{'general.arrangeRight' | transloco}}" class="icon-button buttonBarButt"
                        mat-menu-item (click)="alignSceneItems('RIGHT');">
                    <mat-icon class="buttonBarIcon" style="transform: rotate(-90deg) !important;">equalizer</mat-icon>
                </button>
                <button matTooltip="{{'general.arrangeBottom' | transloco}}" class="icon-button buttonBarButt"
                        mat-menu-item (click)="alignSceneItems('BOTTOM');">
                    <mat-icon class="buttonBarIcon">equalizer</mat-icon>
                </button>
            </mat-menu>

            <button matTooltip="{{'scenes.alignItems' | transloco}}" class="icon-button buttonBarButt" mat-button
                    [disabled]="selectedItemIds.length == 0" [matMenuTriggerFor]="iconGroup2">
                <mat-icon class="buttonBarIcon">format_align_center</mat-icon>
            </button>
            <mat-menu #iconGroup2="matMenu" class="custom-toolbar" [hasBackdrop]="true">
                <button matTooltip="{{'general.alignTop' | transloco}}" class="icon-button buttonBarButt" mat-menu-item
                        (click)="onClickAlign('top');">
                    <mat-icon class="buttonBarIcon" style="transform: rotate(90deg) !important;">format_align_left
                    </mat-icon>
                </button>
                <button matTooltip="{{'general.alignMiddle' | transloco}}" class="icon-button buttonBarButt"
                        mat-menu-item (click)="onClickAlign('middle');">
                    <mat-icon class="buttonBarIcon" style="transform: rotate(90deg) !important;">format_align_center
                    </mat-icon>
                </button>
                <button matTooltip="{{'general.alignBottom' | transloco}}" class="icon-button buttonBarButt"
                        mat-menu-item (click)="onClickAlign('bottom');">
                    <mat-icon class="buttonBarIcon" style="transform: rotate(90deg) !important;">format_align_right
                    </mat-icon>
                </button>
                <button matTooltip="{{'general.alignLeft' | transloco}}" class="icon-button buttonBarButt" mat-menu-item
                        (click)="onClickAlign('left');">
                    <mat-icon class="buttonBarIcon">format_align_left</mat-icon>
                </button>
                <button matTooltip="{{'general.alignCenter' | transloco}}" class="icon-button buttonBarButt"
                        mat-menu-item (click)="onClickAlign('center');">
                    <mat-icon class="buttonBarIcon">format_align_center</mat-icon>
                </button>
                <button matTooltip="{{'general.alignRight' | transloco}}" class="icon-button buttonBarButt"
                        mat-menu-item (click)="onClickAlign('right');">
                    <mat-icon class="buttonBarIcon">format_align_right</mat-icon>
                </button>
            </mat-menu>
        </div>
    }
    <div class="d-flex-center">
        <app-editor-background></app-editor-background>
        <div class="info d-flex-center">
            <button matTooltip="{{'general.dragResolution' | transloco}}" class="icon-button buttonBarButt"
                    mat-button (click)="onClickResolution();">
                <mat-icon class="buttonBarIcon">settings_overscan</mat-icon>
            </button>
            <mat-label style="white-space: nowrap;">&nbsp;<span
                [ngStyle]="{'display': scrWidth > 1350 ? 'inline': 'none'}">{{ 'general.resolution' | transloco }}</span>:
                x{{ resolution }}
            </mat-label>
        </div>
        <!-- Resolution display moved to right side -->
        <div class="info info1 hide-lt-lg" style="margin-left: 10px;">
            <fa-icon [icon]="faExpand" size="xl"></fa-icon>
            @if (selectedItemIds.length == 0 || scrWidth > 1500) {
                <span style="min-width: 100px">&nbsp;{{ editorWidth }} x {{ editorHeight }} </span>
            }
        </div>
    </div>
</div>

@if (breadcrumbs && breadcrumbs.length > 0) {
    <div class="scene-breadcrumbs-bar">
        <div class="breadcrumbs-container">
            <mat-icon class="breadcrumbs-icon">account_tree</mat-icon>
            @for (crumb of breadcrumbs; track crumb.sceneId; let i = $index; let last = $last) {
                <span class="breadcrumb-item"
                      [class.active]="last"
                      [class.clickable]="!last"
                      (click)="!last && navigateToBreadcrumb(i)">
                    {{ crumb.label }}
                </span>
                @if (!last) {
                    <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
                }
            }
        </div>
    </div>
}

<div #contextMenuTrigger style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
     [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="rightContextMenu">
</div>

<mat-menu #rightContextMenu="matMenu" [overlapTrigger]="true" [hasBackdrop]="true" class="custom-context-menu">
    <ng-template matMenuContent let-item="item">
        @if (item.nestedSceneSrc) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="linkToOtherScene(item.nestedSceneSrc)">
                <fa-icon class="fa-menu-icon" [icon]="faLink"></fa-icon>
                <span>{{ 'general.jumpToScene' | transloco }}</span>
            </button>
        }
        @if (item.nestedSceneSrc) {
            <mat-divider></mat-divider>
        }
        <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickCut()" [disabled]="item.isRoot">
            <fa-icon class="fa-menu-icon" [icon]="faCut"></fa-icon>
            <span>{{ 'general.cut' | transloco }}</span>
        </button>
        <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickCopy()" [disabled]="item.isRoot">
            <fa-icon class="fa-menu-icon" [icon]="faCopy"></fa-icon>
            <span>{{ 'general.copy' | transloco }}</span>
        </button>
        <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickPaste(false)"
                [disabled]="!isCut && !isCopy">
            <fa-icon class="fa-menu-icon" [icon]="faPaste"></fa-icon>
            <span>{{ 'general.paste' | transloco }}</span>
        </button>
        <mat-divider></mat-divider>
        <button class="icon-button buttonBarButt" mat-menu-item (click)="onUndoRedo('UNDO');" [disabled]="disableUndo">
            <fa-icon class="fa-menu-icon" [icon]="faUndo"></fa-icon>
            <span>{{ 'general.undo' | transloco }}</span>
        </button>
        <button class="icon-button buttonBarButt" mat-menu-item (click)="onUndoRedo('REDO');" [disabled]="disableRedo">
            <fa-icon class="fa-menu-icon" [icon]="faRedo"></fa-icon>
            <span>{{ 'general.redo' | transloco }}</span>
        </button>
        @if (!item.isRoot) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickBackward()">
                <fa-icon class="fa-menu-icon" [icon]="faArrowUp"></fa-icon>
                <span>{{ 'general.pushBackward' | transloco }}</span>
            </button>
        }
        @if (!item.isRoot) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickForward()">
                <fa-icon class="fa-menu-icon" [icon]="faArrowDown"></fa-icon>
                <span>{{ 'general.pushForward' | transloco }}</span>
            </button>
        }
        @if (!item.isRoot) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickPushToBottom()">
                <fa-icon class="fa-menu-icon" [icon]="faSortAmountUp"></fa-icon>
                <span>{{ 'general.pushBottom' | transloco }}</span>
            </button>
        }
        @if (!item.isRoot) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickPushToTop()">
                <fa-icon class="fa-menu-icon" [icon]="faSortAmountDown"></fa-icon>
                <span>{{ 'general.pushTop' | transloco }}</span>
            </button>
        }
        <mat-divider></mat-divider>
        @if (!item.isRoot) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickLock()">
                <fa-icon class="fa-menu-icon" [icon]="faLock"></fa-icon>
                <span>{{ 'general.lock' | transloco }}</span>
            </button>
        }
        @if (item.isRoot) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="onClickSetGuidelines()">
                <fa-icon class="fa-menu-icon" [icon]="faBorderNone"></fa-icon>
                <span>{{ 'general.magicLines' | transloco }}</span>
            </button>
        }
        @if (!item.isRoot) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="removeSceneItems()">
                <fa-icon class="fa-menu-icon" [icon]="faTrashAlt"></fa-icon>
                <span>{{ 'general.remove' | transloco }}</span>
            </button>
        }
        @if (item.resourceSrc) {
            <mat-divider></mat-divider>
        }
        @if (item.resourceSrc) {
            <button class="icon-button buttonBarButt" mat-menu-item (click)="convertToBackground(item.id)">
                <fa-icon class="fa-menu-icon" [icon]="faImage"></fa-icon>
                <span>{{ 'general.setBackground' | transloco }}</span>
            </button>
        }
    </ng-template>
</mat-menu>

<!--
<context-menu #itemMenuMoveable passive="true">
  <ng-template contextMenuItem (execute)="onClickCut()">Cut</ng-template>
</context-menu>

<context-menu #itemMenuScene>
  <ng-template contextMenuItem (execute)="onClickSetGuidelines()">Toggle Lines</ng-template>
</context-menu> -->

<!--<ng-template let-modal #previewEmbeddedModal>-->
<!--    <div mat-dialog-content>-->
<!--        <div style="width: 1200px">-->

<!--            <h1>Highlight Code</h1>-->
<!--            <pre><code [highlight]="embeddedCode" [lineNumbers]="true"></code></pre>-->
<!--        </div>-->
<!--        &lt;!&ndash;        <div class="helper-image" style="background-color: black; color: #8cff03; overflow: auto">&ndash;&gt;-->
<!--        &lt;!&ndash;            <pre>&ndash;&gt;-->
<!--        &lt;!&ndash;                {{embedded}}&ndash;&gt;-->
<!--        &lt;!&ndash;            </pre>&ndash;&gt;-->
<!--        &lt;!&ndash;        </div>&ndash;&gt;-->
<!--        <button class="icon-button buttonBarButt" mat-raised-button (click)="copyEmbeddedToClipboard()" style="margin-right: 20px;">-->
<!--            <mat-icon class="buttonBarIcon">content_copy</mat-icon>&nbsp;&nbsp;-->
<!--            {{'general.copyCode' | transloco}}-->
<!--        </button>-->
<!--    </div>-->
<!--</ng-template>-->

<ng-template let-modal #keyboardHelperModal>
    <div mat-dialog-content>
        <div class="helper-image">
            <img src="./assets/images/keys.png">
        </div>
    </div>
</ng-template>


<ng-template let-modal #aboutScene>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div style="position: relative; top: -10px">
            <fa-icon size="1x" matTooltip="{{'general.about' | transloco}}" style="font-size: 3em"
                     [icon]="sceneData.Player.$.mimeType | PipeIcon"></fa-icon>
            <label style="font-size: 2em; position: relative; left: 10px; top: -5px; font-weight: lighter">
                [ {{ sceneMimeShort }} ]
            </label>
        </div>
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        <div>
            <ul>
                <li>{{ 'general.assignableTo' | transloco }}: {{ sceneMimeShort }} {{ 'general.scenes' | transloco }}
                </li>
                <li>{{ 'general.name' | transloco }}: {{ sceneData.Player.$.label }}</li>
                <li>{{ 'general.folder' | transloco }}: {{ sceneData.Player.$.folder }}</li>
                <li>{{ 'general.uniqueId' | transloco }}: {{ sceneData.Player.$.id }}</li>
                <li>{{ 'general.dimensions' | transloco }}: {{ editorWidth }} x {{ editorHeight }} px</li>
                <li>{{ 'general.totalBlocks' | transloco }}: {{ sceneItems.length }}</li>
            </ul>
        </div>
    </div>
</ng-template>

<ng-template let-modal #guidelineModal>
    <h1 mat-dialog-title class="header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content class="guideline-modal">
        <div class="row">
            <div class="option">
                  <span>
                    {{ 'general.alpha' | transloco }}
                  </span>
                <mat-slider class="opacity-slider" [disabled]="!isShowLines" [max]="1" [min]="0" [step]="0.1"
                            color="accent">
                    <input matSliderThumb (valueChange)="changeGuidelines()" [(ngModel)]="guidelineOpacity" />
                </mat-slider>
            </div>
            <mat-checkbox class="option" [labelPosition]="'before'" [(ngModel)]="isShowLines"
                          (change)="changeGuidelines()">
                {{ 'general.show' | transloco }}
            </mat-checkbox>
            <button mat-icon-button (click)="onClickRemoveGuidelines()"
                    class="option icon-button buttonBarButt textColorOne">
                <mat-icon class="buttonBarIcon" matTooltip="{{'general.removeGuidelines' | transloco}}">delete
                </mat-icon>
            </button>

        </div>
        <div class="guideline-images" [ngClass]="{'disable': !isShowLines}">
            <img (click)="onClickLineImage(1);" src="./assets/images/guidelines/g1.png">
            <img (click)="onClickLineImage(2);" src="./assets/images/guidelines/g2.png">
            <img (click)="onClickLineImage(3);" src="./assets/images/guidelines/g3.png">
            <img (click)="onClickLineImage(4);" src="./assets/images/guidelines/g4.png">
            <img (click)="onClickLineImage(5);" src="./assets/images/guidelines/g5.png">
            <img (click)="onClickLineImage(6);" src="./assets/images/guidelines/g6.png">
            <img (click)="onClickLineImage(7);" src="./assets/images/guidelines/g7.png">
            <img (click)="onClickLineImage(8);" src="./assets/images/guidelines/g8.png">
            <img (click)="onClickLineImage(9);" src="./assets/images/guidelines/g9.png">
            <img (click)="onClickLineImage(10);" src="./assets/images/guidelines/g10.png">
            <img (click)="onClickLineImage(11);" src="./assets/images/guidelines/g11.png">
            <img (click)="onClickLineImage(12);" src="./assets/images/guidelines/g12.png">
        </div>
    </div>
</ng-template>
<div style="overflow: hidden; height: 0;">
    <div id="newBackground"></div>
</div>

